import React from 'react';
import * as style from './style.module.css';

const TagList = (props: React.HTMLAttributes<HTMLDivElement>) => (
  <div {...props} className={style.wrapper} />
);

TagList.displayName = 'TagList';

export default TagList;
